import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFootball = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2C6.495 2 2 6.495 2 12s4.495 10 10 10 10-4.495 10-10c0-5.474-4.495-9.97-10-10M4.385 7.657c.184-.305.367-.611.581-.917l-.06.52zm15.75 3.793.458-1.315c.123.611.214 1.223.214 1.865v.52zm-6.85 9.296c-.429.03-.857.061-1.285.061a9 9 0 0 1-3.761-.825L6.77 17.229l2.201-2.17 4.098 1.1 1.652 2.783zm-7.707-3.21.52.978a7.4 7.4 0 0 1-1.132-1.254zM3.529 9.797l2.11-1.59L7.81 9.339l.245 4.893-2.14 2.11-1.958-.856A8.8 8.8 0 0 1 3.223 12c0-.734.092-1.498.306-2.202m2.875-4.556c1.437-1.193 3.241-1.896 5.198-1.988v.03l1.53 1.468-.582 2.172-4.036 1.56-2.447-1.285zm2.844 8.562-.214-4.281 3.975-1.53 2.691 3.334-2.293 3.609zm9.296 4.068-2.752.428-1.529-2.539 2.508-3.853h2.17l1.469 2.477c-.306 1.285-.979 2.477-1.866 3.487M14.05 3.835l-.49-.459c.429.092.888.184 1.285.337zm5.076 6.88h-2.354l-2.936-3.639.55-2.018 2.324-.397h.062A8.74 8.74 0 0 1 19.95 8.3zm-3.333 8.839 1.01-.153c-.49.305-.98.58-1.53.795z"
      />
    </svg>
  );
};
export default SvgFootball;
